var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    attrs: {
      id: _vm.id,
      readonly: _vm.readonly,
      autocomplete: _vm.autocomplete,
    },
    on: {
      focus: _vm.selectAll,
      input: function ($event) {
        return _vm.$emit("input", $event.target.value)
      },
      blur: function ($event) {
        return _vm.$emit("blur")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }